import { render, staticRenderFns } from "./Voluum.vue?vue&type=template&id=30bb1f73"
import script from "./Voluum.vue?vue&type=script&lang=js"
export * from "./Voluum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports